/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { TFunction } from 'i18next'

export const COMPANY_ORIGIN_EVENTFORMULAR = 'eventformular'
export const COMPANY_ORIGIN_IMPORT = 'import'
export const COMPANY_ORIGIN_MANUAL = 'manual'

export const COMPANY_ORIGIN_PRESETS = [
    COMPANY_ORIGIN_EVENTFORMULAR,
    COMPANY_ORIGIN_IMPORT,
    COMPANY_ORIGIN_MANUAL,
] as const

/** Legacy contact/account origin values that should display as Eventformular. */
export const LEGACY_EVENTFORMULAR_ORIGINS = new Set([
    'web_lead',
    'web_lead_form',
    'web',
    'website',
])

const ORIGIN_LABEL_MAP: Record<string, string> = {
    [COMPANY_ORIGIN_EVENTFORMULAR]: 'Eventformular',
    [COMPANY_ORIGIN_IMPORT]: 'Import',
    [COMPANY_ORIGIN_MANUAL]: 'Manuelle Erfassung',
}

export const normalizeCompanyOrigin = (origin?: string | null): string => {
    const normalized = (origin ?? '').trim()
    if (!normalized) {
        return ''
    }

    if (LEGACY_EVENTFORMULAR_ORIGINS.has(normalized.toLowerCase())) {
        return COMPANY_ORIGIN_EVENTFORMULAR
    }

    return normalized
}

export const isCompanyOriginPreset = (origin?: string | null): boolean => {
    const normalized = normalizeCompanyOrigin(origin)
    return (COMPANY_ORIGIN_PRESETS as readonly string[]).includes(normalized)
}

export const getCompanyOriginLabel = (
    origin: string | null | undefined,
    t: TFunction
): string => {
    const normalized = normalizeCompanyOrigin(origin)
    if (!normalized) {
        return '-'
    }

    const labelKey = ORIGIN_LABEL_MAP[normalized]
    return labelKey ? t(labelKey) : normalized
}
